import { FC, ReactNode, RefObject, useEffect } from 'react'
import styled from 'styled-components'

import {
  Box,
  Icon,
  IconName,
  IconProps,
  Toast as UiKitToast,
} from '@revolut-internal/ui-kit'

export type ToastProps = {
  timeout: number
  label?: ReactNode
  icon?: IconProps | IconName
  nodeRef?: RefObject<HTMLDivElement | null>
  onDisappear?: VoidFunction
}

const StyledBox = styled(Box)`
  pointer-events: all;
`

export const Toast: FC<ToastProps> = ({ label, icon, timeout, nodeRef, onDisappear }) => {
  const iconProps = typeof icon === 'string' ? { name: icon } : icon

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onDisappear?.()
    }, timeout)

    return () => clearTimeout(timeoutId)
  }, [onDisappear, timeout])

  return (
    <StyledBox ref={nodeRef}>
      <UiKitToast>
        {icon && (
          <UiKitToast.Indicator>
            <Icon {...iconProps} />
          </UiKitToast.Indicator>
        )}

        {label && <UiKitToast.Label>{label}</UiKitToast.Label>}
      </UiKitToast>
    </StyledBox>
  )
}
